module.exports = __webpack_public_path__ + "img/listas-lupa.903b695a.svg";